import { makeStyles } from "@material-ui/core";
import React, { FC } from "react";
import { TheCycleverseTheme } from "src/theme";
import { InputCaption } from "./CalculatorTypography";

type result = {
  value?: string | number;
  valueB?: any;
  valueC?: string | number;
  color?: string;
  title?: string;
  subTitle?: string;
};

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  value: {
    fontWeight: 900,
    fontSize: "30px",
    marginBottom: "20px",
  },
  subTitle: {
    fontWeight: 300,
    fontSize: "30px",
  },
  valueB: {
    fontWeight: 400,
  },

  centerResult: {
    textAlign: "center",
  },
}));

const ResultWithColors: FC<{ results?: result[] }> = ({ results }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {results?.length &&
        results?.map((result, index) => (
          <div key={index} className={classes.centerResult}>
            <InputCaption>{result.title}</InputCaption>
            <div style={{ color: result.color }} className={classes.value}>
              {result.value} <span className={classes.valueB}> {result.valueB} </span> {result.valueC}
            </div>
            <div style={{ color: result.color }} className={classes.subTitle}>
              {result.subTitle}
            </div>
          </div>
        ))}
    </div>
  );
};

export default ResultWithColors;
